// Third party dependencies.
import React from 'react';
import { TouchableOpacity, View } from 'react-native';

// External dependencies.
import Text from '../../../../Texts/Text';
import Icon from '../../../../Icons/Icon';
import { useStyles } from '../../../../../hooks';

// Internal dependencies.
import { ButtonBaseProps } from './ButtonBase.types';
import styleSheet from './ButtonBase.styles';
import {
  DEFAULT_BUTTONBASE_LABEL_COLOR,
  DEFAULT_BUTTONBASE_SIZE,
  DEFAULT_BUTTONBASE_WIDTH,
  DEFAULT_BUTTONBASE_ICON_SIZE,
  DEFAULT_BUTTONBASE_LABEL_TEXTVARIANT,
} from './ButtonBase.constants';

const ButtonBase = ({
  label,
  labelColor = DEFAULT_BUTTONBASE_LABEL_COLOR,
  startIconName,
  endIconName,
  size = DEFAULT_BUTTONBASE_SIZE,
  onPress,
  style,
  width = DEFAULT_BUTTONBASE_WIDTH,
  isDisabled,
  ...props
}: ButtonBaseProps) => {
  const { styles } = useStyles(styleSheet, {
    style,
    size,
    width,
    isDisabled,
  });

  return (
    <TouchableOpacity
      disabled={isDisabled}
      activeOpacity={1}
      onPress={onPress}
      style={styles.base}
      {...props}
    >
      {startIconName && (
        <View style={styles.startIcon}>
          <Icon
            color={labelColor.toString()}
            name={startIconName}
            size={DEFAULT_BUTTONBASE_ICON_SIZE}
          />
        </View>
      )}
      {typeof label === 'string' ? (
        <Text
          variant={DEFAULT_BUTTONBASE_LABEL_TEXTVARIANT}
          style={styles.label}
        >
          {label}
        </Text>
      ) : (
        label
      )}
      {endIconName && (
        <View style={styles.endIcon}>
          <Icon
            color={labelColor.toString()}
            name={endIconName}
            size={DEFAULT_BUTTONBASE_ICON_SIZE}
          />
        </View>
      )}
    </TouchableOpacity>
  );
};

export default ButtonBase;
